import { useState } from 'react'
import Dialog from '@mui/material/Dialog'

import { Button } from '../../../../components/UI'

import { verificationCodeInputs, verificationCodeLength } from '../../../../constants'
import { handleNumberInputWheel } from '../../../../helpers'

const VerificationCodeModal = ({
  open,
  phoneNumber,
  isLoading,
  requestError,
  onSubmit,
  onClose,
}) => {
  const [values, setValues] = useState(verificationCodeInputs.map(() => ''))
  const [error, setError] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleClose = () => {
    onClose()

    setValues(verificationCodeInputs.map(() => ''))
    setError(false)
    setIsSubmitted(false)
  }

  const handleValidate = (validateValues = values) => {
    const codes = validateValues.map((value) => (value.length > 0 ? +value : NaN))

    const isError = codes.findIndex((code) => isNaN(code)) > -1

    setError(isError)

    return isError
  }

  const handleChangeAll = (value, currentInput) => {
    const slicedValue = value.slice(0, verificationCodeLength)
    const inputs = verificationCodeInputs.slice(currentInput)

    inputs.forEach((input) => {
      const inputValue = slicedValue[input]

      if (inputValue?.trim()) {
        setValues((prevState) => {
          const newValues = prevState.map((prevInput, index) =>
            input === index ? inputValue : prevInput
          )

          if (isSubmitted) {
            setTimeout(() => {
              handleValidate(newValues)
            }, 0)
          }

          return newValues
        })
      }
    })
  }

  const handleChange = (target, input) => {
    const value = target.value

    if (
      value.length === 0 &&
      target.previousElementSibling &&
      input !== verificationCodeInputs[0] &&
      values[input - 1] === ''
    ) {
      target.previousElementSibling.focus()
    }

    if (value.length > 1) {
      return handleChangeAll(value, input)
    }

    setValues((prevState) => {
      const newValues = prevState.map((prevInput, index) => (input === index ? value : prevInput))

      if (isSubmitted) {
        setTimeout(() => {
          handleValidate(newValues)
        }, 0)
      }

      return newValues
    })

    if (value.length === 1 && target.nextElementSibling && values[input + 1] === '') {
      target.nextElementSibling.focus()
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!isSubmitted) {
      setIsSubmitted(true)
    }

    const hasError = handleValidate()

    if (hasError) {
      return
    }

    const code = (+values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    )).toString()

    onSubmit(code)
  }

  const codeInputsContent = verificationCodeInputs.map((input) => {
    return (
      <input
        key={input}
        type="number"
        maxLength={1}
        value={values[input]}
        className="without-arrows inline-block w-[20%] bg-white pl-[28px] pr-[14px] h-[56px] rounded-[8px] outline-none border-[#FFCA84] border-[1px] shadow-button text-primary-100 text-2xl font-normal"
        autoFocus={input === verificationCodeInputs[0]}
        onWheel={handleNumberInputWheel}
        onChange={(e) => handleChange(e.target, input)}
      />
    )
  })

  return (
    <Dialog
      open={!!open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      <div className="w-full flex items-center justify-center flex-col">
        <img
          src="/assets/icon/verification-code-phone.svg"
          alt="Phone"
          className="w-[100px] h-[178px]"
        />

        <h2 className="text-primary-100 text-xl font-bold mt-[16px]">Verification Code</h2>

        {phoneNumber && (
          <p className="text-center font-medium text-primary-100 text-sm leading-[19px]">
            Please input the code sent to your mobile device with the following number:{' '}
            <b className="font-bold">{phoneNumber}</b>
          </p>
        )}

        <form className="mt-[24px] w-full flex flex-col" onSubmit={handleSubmit}>
          <div className="w-full flex items-center gap-x-[24px]">{codeInputsContent}</div>

          {(requestError || error) && (
            <p className="mt-[4px] text-[#F04438] text-sm font-normal">
              {requestError || 'Wrong Verification code'}
            </p>
          )}

          <Button type="submit" className="mt-[24px] text-lg font-semibold" isLoading={isLoading}>
            Verify
          </Button>
        </form>
      </div>
    </Dialog>
  )
}

export default VerificationCodeModal
